import { useState, useEffect } from "react";
import Loader from "components/Loader";
import MobileSupportTabBar from "components/TabBars/MobileSupportTabBar";
import HelpCard from "components/Cards/HelpCard";
import { Button, Col, Form } from "react-bootstrap";
import Validator from "utils/Validator";
import classNames from "classnames";
import { css } from "aphrodite";
import pageStyles from "styles/pageStyles";
import { getInputFieldStyle, getButtonStyle } from "utils/formStyles";

export default function Page() {
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    domain_link: "",
    brand_name: "",
  });
  const [isResultGot, setIsResultGot] = useState(false);
  const [errors, setErrors] = useState({ brandName: "", webSite: "" });
  const [webSite, setWebSite] = useState("");
  const [brandName, setBrandName] = useState("");
  const [showSearchItem, setShowSearchItem] = useState("");
  const [tabs, setTabs] = useState([]);
  const firstLevelTopic = "SEO";
  const secoundLevelTopic = "Meta Description";
  const thirdLevelTopic = "URL";

  const handleBrandNameChange = (e) => {
    setBrandName(e.target.value);
  };

  const handleWebSiteChange = (e) => {
    setWebSite(e.target.value);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = "";
    if (
      name === "webSite" &&
      !Validator.validateRequired(value, Validator.validateUrl)
    ) {
      error = "Invalid URL";
    } else if (
      name === "brandName" &&
      !Validator.validateRequired(value, Validator.validateBrandName)
    ) {
      error = "Please enter brand name";
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleReset = () => {
    setShowSearchItem("");
    setIsResultGot(false);
    setWebSite("");
    setBrandName("");
    setErrors({ webSite: "", brandName: "" });
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      console.log(formData);
      // const result = await get_seo_meta_description_for_single_keyword(
      //   formData
      // );
      // setShowSearchItem(formData.domainLink)
      // setTabs([
      //   {
      //     label: "Draft A",
      //     element: (
      //       <ArticleHeadlinesKeywordTable
      //         data={result.gpt}
      //         topic={thirdLevelTopic}
      //       />
      //     ),
      //   },
      //   {
      //     label: "Draft B",
      //     element: (
      //       <ArticleHeadlinesKeywordTable
      //         data={result.gemini}
      //         topic={thirdLevelTopic}
      //       />
      //     ),
      //   },
      //   {
      //     label: "Draft C",
      //     element: (
      //       <ArticleHeadlinesKeywordTable
      //         data={result.claude}
      //         topic={thirdLevelTopic}
      //       />
      //     ),
      //   },
      // ]);
      setIsResultGot(true);
    } catch (error) {
      console.error("Submission error:", error);
      setIsResultGot(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    let isValid =
      Validator.validateRequired(webSite, Validator.validateUrl) &&
      Validator.validateRequired(brandName, Validator.validateBrandName);
    if (isValid) {
      setFormData({
        domain_link: webSite,
        brand_name: brandName,
      });
    }
    setIsFormValid(isValid);
  }, [brandName, webSite]);

  return (
    <div className={classNames("container-fluid", css(pageStyles.container))}>
      <h1 className="d-flex fw-normal justify-content-start align-items-center fw-bold">
        {secoundLevelTopic}
      </h1>
      <p className="fw-normal justify-content-start align-items-center">
        {firstLevelTopic} / {secoundLevelTopic} / <b>{thirdLevelTopic}</b>
      </p>
      <p className="fw-normal justify-content-start align-items-center">
        The SEO Meta Description at the page level involves crafting a unique,
        concise summary for each individual webpage, which appears as the
        snippet below the title in search engine results pages (SERPs). This
        specificity aids search engines in accurately representing page content,
        enhancing relevance signals and user trust, while mitigating risks of
        generic or duplicate descriptions that could dilute crawl efficiency or
        trigger penalties. In 2025's evolving search landscape, including
        AI-generated summaries, page-level optimization can improve
        click-through rates by 15-25% by aligning precisely with user intent,
        fostering better engagement and supporting site-wide authority without
        compromising broader SEO coherence.
      </p>
      <div className="row">
        <div className="col-lg-9 col-md-10 col-sm-10">
          <HelpCard
            topic={"How To Use"}
            description={
              "Develop a tailored meta description for every page using the HTML <meta name='description' content='...'> tag or CMS integrations like Yoast SEO, limiting length to 140-160 characters to ensure complete visibility in SERPs. Incorporate the page's primary keyword naturally, reflect its unique value proposition, and include a compelling call-to-action that matches the page's intent (e.g., 'Explore expert insights on [Topic] tailored for professionals | Brand Name). Ensure descriptions are non-duplicative across the site; audit with tools."}
            image={"/icon/pin.svg"}
          />
        </div>
      </div>
      <div className="p-2 mb-2 rounded">
        <div className="d-flex fw-bold mb-0">Generate Meta Description</div>
        <div className="row mb-2 align-items-end">
          <div className="mb-2">
            <p className="fw-normal justify-content-start align-items-center">
              Enter your website URL and brand name to generate meta
              descriptions.
            </p>
            <Form.Group>
              <div className="d-flex mt-2">
                <Col sm={4} className="me-2">
                  <Form.Control
                    type="text"
                    name="webSite"
                    placeholder="Enter Website URL"
                    value={webSite}
                    onChange={handleWebSiteChange}
                    onBlur={handleBlur}
                    isInvalid={!!errors.webSite}
                    required
                    className="px-2"
                  />
                </Col>
                <Col sm={4} className="me-2">
                  <Form.Control
                    type="text"
                    name="brandName"
                    placeholder="Enter Brand Name"
                    value={brandName}
                    onChange={handleBrandNameChange}
                    onBlur={handleBlur}
                    isInvalid={!!errors.brandName}
                    required
                    className="px-2"
                  />
                </Col>
                <div className="col-lg-4 col-md-4 col-sm-12 mb-2">
                  <div className="d-flex justify-content-start align-items-end">
                    <Button
                      variant="dark"
                      className="me-1"
                      onClick={handleSubmit}
                      disabled={!isFormValid}
                      style={getButtonStyle('type3', 'primary')}
                    >
                      Search
                    </Button>
                    <Button
                      variant="outline-dark"
                      className="me-1"
                      onClick={handleReset}
                      style={getButtonStyle('type3', 'outline')}
                    >
                      Reset
                    </Button>
                  </div>
                </div>
              </div>
            </Form.Group>
          </div>
        </div>
      </div>

      <div className="p-2">
        {showSearchItem !== "" && (
          <div>
            <p className="d-flex fw-bold mb-0">
              Meta descriptions for
              <span className="search-item">&nbsp;"{showSearchItem}"</span>
            </p>
          </div>
        )}
        {isLoading && <Loader />}
        {isResultGot && <MobileSupportTabBar tabs={tabs} />}
      </div>
    </div>
  );
}
